export default __webpack_public_path__ + "static/media/dog-avatar.2546fae7.svg";